import { ApplicantDetails } from './applicant-details';

import { DataProtection } from './data-protection';
import { DecisionDetails } from './decision-details';
import { EducationDetails } from './education-details';
import { EmployerDetails } from './employer-details';
import { EmployerSponsorDetails } from '../models/employer-sponsor-details';
import { FeedbackDetails } from './feedback-details';
import { HealthDetails } from '../models/health-details';
import { InvestmentDetails } from '../models/investment-details';
import { OccupationDetails } from './occupation-details';
import { RelationshipPartner } from '../models/relationship-partner';
import { SponsorDetails } from './sponsor-details';
import { BusinessDetails } from '../models/business-details';

export class InitialAssessmentForm {
  loadedFormId: string | null = null;
  applyOrSponsor: string | null = null;
  formType: any = null;
  contactDetails: any = null;
  applicantDetails: ApplicantDetails | null = null;
  hasSponsor: string | boolean | null = null;
  sponsorDetails: SponsorDetails | null = null;
  relationshipPartner: RelationshipPartner | null = null;
  education: EducationDetails | null = null;
  employer: EmployerDetails | null = null;
  occupation: OccupationDetails | null = null;
  business: BusinessDetails | null = null;
  investment: InvestmentDetails | null = null;
  feedback: FeedbackDetails | null = null;
  history: any = null;
  health: HealthDetails | null = null;
  employerSponsor: EmployerSponsorDetails | null = null;
  decision: DecisionDetails | null = null;
  dataProtection: DataProtection | null = null;
	redirectUrl: string | null = null;
  enquiryType: string | null = null;

  public static create(formType: string, applyOrSponsor?: string | null) {
    const form = new InitialAssessmentForm();
    form.formType = formType;
    form.applyOrSponsor = applyOrSponsor || null;
    form.loadedFormId = null;

    return InitialAssessmentForm.buildApplication(form);
  }

  //Populate an application with the correct sections.
  public static buildApplication(application: InitialAssessmentForm) {
    switch (application.formType) {
      case 'appealCancel':
      case 'appealRefuse':
        return InitialAssessmentForm.buildAppealApplication(application);
      case 'business':
        return InitialAssessmentForm.buildBusinessApplication(application);
      case 'sponsor-child':
      case 'sponsor-parent':
        return InitialAssessmentForm.buildFamilySponsorApplication(application);
      case 'sponsor-partner':
        return InitialAssessmentForm.buildPartnerApplication(application);
      case 'skilled-visa':
      case 'work':
        return InitialAssessmentForm.buildWorkApplication(application);
      case 'study':
        return InitialAssessmentForm.buildStudyApplication(application);
      case 'employerTemp':
      case 'employerPerm':
        return InitialAssessmentForm.buildEmployerApplication(application);
      case 'generic':
        return InitialAssessmentForm.buildGenericApplication(application);
      case 'businessEnquiry':
        return InitialAssessmentForm.buildBusinessEnquiry(application);
      case 'visit':
        return InitialAssessmentForm.buildVisitApplication(application);
      case 'enquiry':
        return InitialAssessmentForm.buildGeneralEnquiry(application);
      case 'vevo-myself':
      case 'vevo-employee':
      case 'vevo-contract':
        return InitialAssessmentForm.buildVevoSearch(application);


    }

    throw new Error('Unknown application type: ' + application.formType);
  }

    private static buildVevoSearch(application: InitialAssessmentForm){
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.employer) {
      application.employer = new EmployerDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildAppealApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.decision) {
      application.decision = new DecisionDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildBusinessApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.education) {
      application.education = new EducationDetails();
    }

    if (!application.business) {
      application.business = new BusinessDetails();
    }

    if (!application.health) {
      application.health = new HealthDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    if (!application.investment) {
      application.investment = new InvestmentDetails();
    }

    return application;
  }

  private static buildFamilySponsorApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.sponsorDetails) {
      application.sponsorDetails = new SponsorDetails();
    }

    if (!application.health) {
      application.health = new HealthDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildPartnerApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.sponsorDetails) {
      application.sponsorDetails = new SponsorDetails();
    }

    if (!application.relationshipPartner) {
      application.relationshipPartner = new RelationshipPartner();
    }

    if (!application.health) {
      application.health = new HealthDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildWorkApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.employer) {
      application.employer = new EmployerDetails();
    }

    if (!application.education) {
      application.education = new EducationDetails();
    }

    if (!application.occupation) {
      application.occupation = new OccupationDetails();
    }

    if (!application.health) {
      application.health = new HealthDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildStudyApplication(application: InitialAssessmentForm) {

    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.education) {
      application.education = new EducationDetails();
    }

    if (!application.health) {
      application.health = new HealthDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildEmployerApplication(application: InitialAssessmentForm) {
    if (!application.employer) {
      application.employer = new EmployerDetails();
    }

    if (!application.employerSponsor) {
      application.employerSponsor = new EmployerSponsorDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildGenericApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildBusinessEnquiry(application: InitialAssessmentForm) {
    if (!application.employer) {
      application.employer = new EmployerDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildVisitApplication(application: InitialAssessmentForm) {
    if (!application.applicantDetails) {
      application.applicantDetails = new ApplicantDetails();
    }

    if (!application.sponsorDetails) {
      application.sponsorDetails = application.hasSponsor === true ? new SponsorDetails() : null;
    }

    if (!application.occupation) {
      application.occupation = new OccupationDetails();
    }

    if (!application.health) {
      application.health = new HealthDetails();
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }

  private static buildGeneralEnquiry(application: InitialAssessmentForm) {
    switch (application.applyOrSponsor) {
      case 'sponsorEmployee':
        application.applicantDetails = null;

        if (!application.employer) {
          application.employer = new EmployerDetails();
        }
        break;
      case 'apply':
        if (!application.applicantDetails) {
          application.applicantDetails = new ApplicantDetails();
        }

        application.employer = null;

        break;
      default:
        if (!application.applicantDetails) {
          application.applicantDetails = new ApplicantDetails();
        }
    }

    if (!application.feedback) {
      application.feedback = new FeedbackDetails();
    }

    return application;
  }
}
